var map = {
	"./0.jpg": 8056,
	"./1.jpg": 1412,
	"./2.jpg": 3988,
	"./3.jpg": 6936,
	"./Maker Space.jpg": 1208,
	"./STEM实验室.jpg": 5399,
	"./VEX实验室.jpg": 4644,
	"./人工智能+无人机.jpg": 4836,
	"./集装箱实验室.jpg": 6860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5827;